import { render, staticRenderFns } from "./adminexamine.vue?vue&type=template&id=201712d0&scoped=true"
import script from "./adminexamine.vue?vue&type=script&lang=js"
export * from "./adminexamine.vue?vue&type=script&lang=js"
import style0 from "./adminexamine.vue?vue&type=style&index=0&id=201712d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201712d0",
  null
  
)

export default component.exports